import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {FormControl, FormBuilder, FormGroup, Validators} from '@angular/forms';
import { BehaviorSubject, Observable } from 'rxjs';
import { fuseAnimations } from '@fuse/animations';
import { ForAllService } from "../for-all.service";
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
import {TranslateService} from '@ngx-translate/core';
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatDialog } from '@angular/material/dialog';
import * as $ from 'jquery';
import Swal from 'sweetalert2';
import { PreguntasService } from "app/main/pagina/productos/certificar/tipo_2/preguntas/preguntas.service";
import { SurveyProductService } from "app/main/wizard-cgo/survey-product/survey-product.service";
import { ModalComponent } from "app/main/pagina/productos/certificar/tipo_2/preguntas/reactivos-v3/preguntas/modal/modal.component";
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'practicas',
  templateUrl: './practicas.component.html',
  styleUrls: ['./practicas.component.scss'],
  animations   : fuseAnimations
})
export class PracticasComponent implements OnInit {

  comunicacionPracticas: any;
  @Input() statusPaso: Observable<any>;
  comunicacionTraducciones: any;
  @Input() actualizaCuestionarioTrad: Observable<any>;

  @Output() actualizaTraducciones: EventEmitter<any> = new EventEmitter();
  @Output() numeroPracticasRequeridas: EventEmitter<any> = new EventEmitter();
  @Output() idiomasGuardados: EventEmitter<any> = new EventEmitter();
  @Output() seccionesGuardadas: EventEmitter<any> = new EventEmitter();

  cargando = true;
  guardando: boolean;
  pasoCompleto: boolean;
  idiomas: any;

  displayedColumns = ['practice', 'description', 'statement1', 'statement2'];
  productoCertificar:any;
  numeroPracticas: number;
  statement1: string;
  statement2: string;
  statement1Part1: string;
  statement1Part2: string;
  statement2Part1: string;
  statement2Part2: string;
  nombreEmpresa: string;

  dataSource: any[];
  dataSourceOriginal: any[];

  formGroupForAll: FormGroup;

  instituto: string;
  idiomaNative = 'es';
  catalogoRespForall: any;
  pregStatement1: any;
  pregStatement2: any;
  jsonCuestionario: any;
  seccionesDemo: any[] = [];
  configTemplate = {
    nuevasPreguntas: true,
    preguntasMC: true,
    movibles: true,
    editables: true,
    eliminables: true,
    audios: false,
    required4all: true,
    nuevasSecciones: true,
    secMovibles: true,
    secEditables: true,
    secEliminables: true,
    audiosGlobal: false,
    limites: {
      demograficos: 5,
      abiertas: 5,
      forall: 5,
      adicionales: 5,
      preguntasMaximas: 5
    }
  };
  configItbm: boolean;

  catalogoRespReactivos: any;
  catalogoIdiomasSurvey: any;
  nameUserAdmin:any="";
  userData:any;
  validationUser:boolean=false;

  constructor(
    private forallService: ForAllService,
    private wizardService: WizardService,
    private translate: TranslateService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private preguntasService: PreguntasService,
    public sanitizer: DomSanitizer,
    private surveyProductService: SurveyProductService
  ) {
    // this.getParams();
    if(localStorage.getItem("userBypass")){
      this.configItbm = true;
      this.userData=JSON.parse(localStorage.getItem('userBypass'));
      // console.log(this.userData.level);
      if(this.userData.level==3 || this.userData.level==2){
        this.validationUser=true;
        this.nameUserAdmin=this.userData.user;
      }
      else{
        this.validationUser=false;
        this.nameUserAdmin="";
      }


    }else{
      this.configItbm = false;
    }
  }

  ngOnInit() {
    this.comunicacionPracticas = this.statusPaso.subscribe( (datos) => {
      if(datos != null){
        console.log("se envio datos desde componente base: ",datos);
        this.pasoCompleto = datos;
        if(this.pasoCompleto){
          this.bloqueaPracticas();
        }
      }
    });
    this.comunicacionTraducciones = this.actualizaCuestionarioTrad.subscribe( (datos:any) => {
      if(datos != null){
        console.log("se envio desde traducciones:",datos);
        if(datos == true){
          this.actualizaCuestionario(3);
        }
      }
    });
    this.getCertificar();
    this.getCatIdiomasSurvey();
  }



  getCertificar(){
    this.preguntasService.getProdCertAct().subscribe((data:any) => {
      let prodsCertificar:any[] = data.productosCertificar;
      let indiceProducto = prodsCertificar.findIndex(item => item.fechaCertificar == parseInt(localStorage.getItem('fechaProducto')) && item.idCertificar == localStorage.getItem('productoID'));
      if(indiceProducto != -1){
        this.productoCertificar = prodsCertificar[indiceProducto];
        this.getSeccionesCuestionario();

      }
    }, error  => {
      console.log("error al recuperar certificar vigente");
    });
  }

  obtieneIdiomasGuardados(){
    let datos: any = {productoId:this.productoCertificar.idCertificar};
    this.preguntasService.getIdiomasProd(datos).subscribe( (data: any) => {
      this.idiomas = data.idiomasMostrar;
      this.idiomasGuardados.emit(this.idiomas);
      let indiceIdiomaNativo = this.idiomas.findIndex(item => item.tipoIdioma == "1");
      this.idiomaNative = this.idiomas[indiceIdiomaNativo].nombreIdioma;
      this.getCatRespuestasReactivos();
      this.getCatDatosForAll();
    });
  }

  getSeccionesCuestionario(){
    this.preguntasService.getSeccionesCuestionario(this.productoCertificar.surveyProductId._id).subscribe((respuesta:any) => {
      console.log("getSeccCuestionario:",respuesta);
      this.jsonCuestionario = respuesta.surveyproduct;
      this.nombreEmpresa = this.jsonCuestionario.companyId.datosEmpresa.nombreEmpresa;
      let tipoSeccion = 6;
      this.seccionesDemo = [];
      this.jsonCuestionario.sections.forEach((seccion:any) => {
        if(seccion.typeSection == tipoSeccion){
          this.seccionesDemo.push(seccion);
        }
      });
      this.setConfiguracionInicial();
      // this.DEMO_colocaAudiosPregunta();
      if(this.seccionesDemo.length == 0){
        this.creaSeccionForall();
      }
      console.log("seccionesDemoTemplate:",this.seccionesDemo);
    this.obtieneIdiomasGuardados();
    });
  }

  DEMO_colocaAudiosPregunta(){
    this.seccionesDemo.forEach(seccion => {
      seccion.questions.forEach(pregunta => {
        pregunta.questionLanguage.forEach(idioma => {
          idioma.audio = false;
          idioma.audioData = '';
          idioma.audioUrl = '';
        });
      });
    });
  }

  creaSeccionForall(){
    let idiomasNuevaSeccion: any[] = [];
    this.idiomas.forEach(idioma => {
      if(idioma.tipoIdioma == 0 || idioma.tipoIdioma == 1){
        let indiceIDlangSurv = this.catalogoIdiomasSurvey.findIndex(item => item.abbr == idioma.nombreIdioma);
        let textoPreguntaNuevo = "";
        // if(idioma.tipoIdioma == 1){
          textoPreguntaNuevo = 'ForAll';
        // }
        idiomasNuevaSeccion.push({
          idLanguage: this.catalogoIdiomasSurvey[indiceIDlangSurv].idLanguage,
          lang: idioma.nombreIdioma,
          textSection: textoPreguntaNuevo,
          vivo: 1
        });
      }
    });
    let seccionNueva:any = {
      addCatQuestions: this.configTemplate.preguntasMC,
      addNewQuestions: this.configTemplate.nuevasPreguntas,
      color: 1,
      deleteQuestions: this.configTemplate.eliminables,
      editQuestions: this.configTemplate.editables,
      logicSection: "",
      maxQuestions: this.configTemplate.limites.preguntasMaximas,
      moveQuestions: this.configTemplate.movibles,
      nameSection: 'ForAll',
      orderSection: 99,
      questions: [],
      sectionsLanguages: idiomasNuevaSeccion,
      typeSection: 6,
      vivo: 1
    };
    this.seccionesDemo.push(seccionNueva);
    this.actualizaOrdenSeccionesTemplate();
  }

  setConfiguracionInicial(){
    this.configTemplate = {
      nuevasPreguntas: this.seccionesDemo[0] != undefined ? this.seccionesDemo[0].addNewQuestions : true,
      preguntasMC: this.seccionesDemo[0] != undefined ? this.seccionesDemo[0].addCatQuestions : true,
      movibles: this.seccionesDemo[0] != undefined ? this.seccionesDemo[0].moveQuestions : true,
      editables: this.seccionesDemo[0] != undefined ? this.seccionesDemo[0].editQuestions : true,
      eliminables: this.seccionesDemo[0] != undefined ? this.seccionesDemo[0].deleteQuestions : true,
      audios: this.seccionesDemo[0] != undefined ? this.seccionesDemo[0].enableAudio : false,
      required4all: this.seccionesDemo[0] != undefined ? this.seccionesDemo[0].required4all : true,
      nuevasSecciones: this.jsonCuestionario.addSections,
      secMovibles: this.jsonCuestionario.moveSections,
      secEditables: this.jsonCuestionario.editSections,
      secEliminables: this.jsonCuestionario.deleteSections,
      audiosGlobal: this.jsonCuestionario.enableAudio,
      limites: {
        demograficos: 5,
        abiertas: 5,
        forall: 5,
        adicionales: 5,
        preguntasMaximas: this.seccionesDemo[0] != undefined ? this.seccionesDemo[0].maxQuestions : 5
      }
    };
  }

  actualizaOrdenSeccionesTemplate(){
    let indiceInicial: number;
    let seccionesDepuradas: any[] = [];
    this.jsonCuestionario.sections.forEach((seccion, i) => {
      if(seccion.typeSection == 6){
        if(indiceInicial == null){
          indiceInicial = i;
        }
      }
      else{
        seccionesDepuradas.push(seccion);
      }
    });
    this.jsonCuestionario.sections = seccionesDepuradas;
    this.jsonCuestionario.sections.splice(indiceInicial, 0, ...this.seccionesDemo);
    this.jsonCuestionario.sections.sort( (a,b) => { if(a.typeSection > b.typeSection){ return 1; } else{ return -1; } });
    this.jsonCuestionario.sections.forEach((seccion, i) => {
      seccion.orderSection = (i+1);
    });
  }

  getCatRespuestasReactivos(){
    this.preguntasService.getCatRespuestasReactivos().subscribe((respuesta:any) => {
      console.log("getCatRespuestasReactivos",respuesta);
      this.catalogoRespReactivos = respuesta.answers;
      let idiomasActuales: any[] = [];
      this.idiomas.forEach(idioma => {
        if(idioma.tipoIdioma == 0 || idioma.tipoIdioma == 1){
          idiomasActuales.push(idioma.nombreIdioma);
        }
      });
      this.catalogoRespReactivos.forEach(respReactivo => {
        let listaIdiomasResp: any[] = [];
        respReactivo.answerLanguage.forEach(idiomaResp => {
          if(idiomasActuales.includes(idiomaResp.lang)){
            listaIdiomasResp.push(idiomaResp);
          }
        });
        respReactivo.answerLanguage = listaIdiomasResp;
      });
      console.log("catalogoRespReactivosFinal:",this.catalogoRespReactivos);

    });
  }

  getCatDatosForAll(){
    let statement1:any;
    let statement2:any;
    this.preguntasService.getCatDatosForAll().subscribe((respuesta:any) => {
      console.log("getCatForall",respuesta);
      this.catalogoRespForall = respuesta.questions;
      this.pregStatement1 = respuesta.questions[0];
      this.pregStatement2 = respuesta.questions[1];
      console.log("catalogoRespForallFinal:",this.catalogoRespForall);
      this.pregStatement1.questionLanguage.forEach(element => {
        if(element.lang== this.idiomaNative){
          this.statement1=element.question;
        }
      });
      console.log("this.statement1",this.statement1);


      this.pregStatement2.questionLanguage.forEach(element => {
        if(element.lang== this.idiomaNative){
          this.statement2=element.question;
        }
      });
      console.log("statement1:",this.statement1,"statement2:",this.statement1);
      this.statement1Part1 = this.statement1.split("$replace1")[0];
      this.statement1Part2 = this.statement1.split("$replace1")[1];
      this.statement2Part1 = this.statement2.split("$replace1")[0];
      this.statement2Part2 = this.statement2.split("$replace1")[1];
      this.statement2Part2 = this.statement2Part2.split("$replace2")[0];
      // console.log("parte1",this.statement1Part1);
      // console.log("parte2",this.statement1Part2);
      // console.log("lo que quiero saber",this.statement2Part2);
      this.colocarPracticaForall();
      this.enviaSeccionesDemo();
    });
  }

  buscaUltimaIdUnique1000(){
    let arregloIds: any[] = [1000];
    this.jsonCuestionario.sections.forEach((seccion:any) => {
      seccion.questions.forEach(pregunta => {
        if(pregunta.idUnique > 1000){
          arregloIds.push(pregunta.idUnique);
        }
      });
    });
    arregloIds.sort((a,b)=>a-b);
    console.log("ultimoIdUnique:",arregloIds[arregloIds.length - 1]);
    return arregloIds[arregloIds.length - 1] + 1;
  }

  enviaSeccionesDemo(){
    console.log("emitira info a traducciones");

    this.seccionesGuardadas.emit({
      jsonCuestionario: this.jsonCuestionario,
      tipoSeccion: 6,
      seccionesDemo: this.seccionesDemo,
      catalogoRespForall: this.catalogoRespForall,
      idiomaNative: this.idiomaNative,
      configTemplate: this.configTemplate
    });
  }

  getInstituto(){
    switch(this.wizardService.getInstituto()){
      case '1': case 'MX': this.instituto = 'MX'; break;
      case '2': case 'CAyC': this.instituto = 'CAyC'; break;
      case '3': case 'HK': this.instituto = 'HK'; break;
      case '4': case 'SGP': this.instituto = 'SGP'; break;
      case '5': case 'TK': this.instituto = 'TK'; break;
      case '6': case 'FL': this.instituto = 'FL'; break;
      case '8': case 'IZZI': this.instituto = 'IZZI'; break;
      case '11': case 'BR': this.instituto = 'BR'; break;
      case '15': case 'ES': this.instituto = 'ES'; break;
    }
  }

  colocarPracticaForall(){
    this.dataSource = [];
    let contadorPregMax = -1;
    let preguntasSeccionTemp = [];
    for (let i = 0; i < this.configTemplate.limites.preguntasMaximas; i++) {
      this.dataSource.push(
        {
          position: i,
          practice: '',
          description: '',
          statement1: '',
          statement2: '',
          statement1Part1: this.statement1Part1,
          statement1Part2: this.statement1Part2,
          statement2Part1: this.statement2Part1,
          statement2Part2: this.statement2Part2
        }
      );

      ///adapta la seccionDemo al numero de preguntasMaximas
      contadorPregMax++;
      this.seccionesDemo[0].questions[contadorPregMax] != undefined ? preguntasSeccionTemp.push(this.seccionesDemo[0].questions[contadorPregMax]) : false;
      contadorPregMax++;
      this.seccionesDemo[0].questions[contadorPregMax] != undefined ? preguntasSeccionTemp.push(this.seccionesDemo[0].questions[contadorPregMax]) : false;
    }
    console.log("this.dataSource",this.dataSource);

    this.seccionesDemo[0].questions = preguntasSeccionTemp;

    let contador=1;
    let practicaActual=0;
    console.log("this.seccionesDemo[0]",this.seccionesDemo[0]);
    console.log("preguntasSeccionTemp",preguntasSeccionTemp);

    this.seccionesDemo[0].questions.forEach((element, i) => {
      if(this.dataSource[practicaActual] != undefined){
        let indiceIdioma= element.questionLanguage.findIndex(item=>item.lang==this.idiomaNative);
        if (indiceIdioma!= -1) {
          switch (contador) {
            case 1:
            console.log("indiceIdioma:::",indiceIdioma);

            this.dataSource[practicaActual].practice=element.questionLanguage[indiceIdioma].practice4all;
            this.dataSource[practicaActual].description=element.questionLanguage[indiceIdioma].description4all;
            this.dataSource[practicaActual].statement1=element.questionLanguage[indiceIdioma].question;
            this.dataSource[practicaActual].objetoStatement1=element;
            break;
            case 2:
            this.dataSource[practicaActual].statement2=element.questionLanguage[indiceIdioma].question;
            this.dataSource[practicaActual].objetoStatement2=element;
            break;
          }
        }
        if (contador < 2) {
          contador++;
        }else{
          contador=1;
          practicaActual++;
          console.log("practicaActual",practicaActual);
        }
      }
    });
    this.cargando = false;
    this.creaFormGroups();
    this.dataSourceOriginal = JSON.parse(JSON.stringify(this.dataSource));    //forma medio chambona de clonar arrays, pero jaló alv
    console.log("dataSourceFinal:",this.dataSource);
  }

  getCatIdiomasSurvey(){
    this.preguntasService.getCatIdiomasSurvey().subscribe((respuesta:any) => {
      // console.log("getCatIdiomasSurvey",respuesta);
      this.catalogoIdiomasSurvey = respuesta.languages;
    });
  }

  creaFormGroups(){
    let group = {};
    let iterador = 0;
    this.dataSource.forEach( (practica) => {
      group["practica"+iterador] = new FormControl({ value: practica.practice, disabled: this.pasoCompleto });
      group["descrip"+iterador] = new FormControl({ value: practica.description, disabled: this.pasoCompleto });
      iterador++;
    });
    this.formGroupForAll = new FormGroup(group);
    console.log("formGroupForAll:",this.formGroupForAll);

    this.formGroupForAll.valueChanges.subscribe( (res) => {
      if(this.formGroupForAll.status == 'VALID'){
        // this.formValido.emit(true);
        // console.log('formulario completo');
      }
      else{
        // this.formValido.emit(false);
        // console.log('formulario incompleto');
      }
    }
    );
  }

  bloqueaPracticas(){
    for(let k in this.formGroupForAll.controls){
      this.formGroupForAll.controls[k].disable();
    }
  }

  actualizaStatement(event:any, posicion:number){
    // console.log("pregunta a editar ",this.statement1);
    if(event.target.value.length >= 1){
      this.dataSource[posicion].statement1 = this.statement1.replace('$replace1',event.target.value);
      this.dataSource[posicion].practice = event.target.value;
      this.dataSource[posicion].statement2 = this.statement2.replace('$replace1',event.target.value).replace('$replace2',this.nombreEmpresa);
    }
  }

  actualizaStatementDescripcion(event:any, posicion:number){
    // console.log("est jalo",this.dataSource[posicion]);
    if(event.target.value.length >= 1){
      this.dataSource[posicion].description = event.target.value;
    }
  }

  guardaDatosPractica(event:any, posicion:number, tipo:number){
    if(!this.guardando){
      if(event.target.value.length >= 1){
        let textoOriginal: any;
        let accionText: any;
        switch (tipo) {
          case 1: //practica
            textoOriginal = this.dataSourceOriginal[posicion].practice;
            accionText='savePracticaForall';
          break;
          case 2: //descripcion
            textoOriginal = this.dataSourceOriginal[posicion].description;
            accionText='saveDescripForall';
          break;
        }
        console.log("textoDS:",textoOriginal," textoTaget:",event.target.value);
        if(textoOriginal != event.target.value)
        {
          // this.guardando = true;
          $(document).ready(function(){ $(':focus').blur(); });
          this.modalGuardado(tipo);
          let idiomasNuevaPreguntaEmpresaStatement1: any[] = [];
          let idiomasNuevaPreguntaEmpresaStatement2: any[] = [];
          let objetoStatement1: any[] = [];
          this.pregStatement1.answers.forEach(element => {
            let objAnswer: any = {
              answerLanguage: element.answerLanguage,
              delete: true,
              edit: true,
              idUnique: element.idUnique,
              logics: [],
              value: element.value,
              versionId: element.versionId,
              vivo: 1,
            };
            objetoStatement1.push(objAnswer);
          });
          console.log("dataSource:",this.dataSource[posicion]);

          this.idiomas.forEach(idioma => {
            if(idioma.tipoIdioma == 0 || idioma.tipoIdioma == 1){
              let indiceIDlangSurv = this.catalogoIdiomasSurvey.findIndex(item => item.abbr == idioma.nombreIdioma);
              let textoPreguntaNuevo = "";
              let objetoIdiomaStt: any = {
                idLanguage: this.catalogoIdiomasSurvey[indiceIDlangSurv].idLanguage,
                lang: idioma.nombreIdioma,
                question: '',
                description4all: '',
                practice4all: '',
                vivo: 1,
                //elementos provisionales audio
                audio: false,
                audioData: '',
                audioUrl: ''
              };
              let objSt1 = JSON.parse(JSON.stringify(objetoIdiomaStt));
              let objSt2 = JSON.parse(JSON.stringify(objetoIdiomaStt));
              if(idioma.tipoIdioma == 1){
                // textoPreguntaNuevo = event.target.value;
                objSt1.description4all = this.dataSource[posicion].description;
                // objSt2.description4all = this.dataSource[posicion].description;
                objSt1.practice4all = this.dataSource[posicion].practice;
                objSt2.practice4all = this.dataSource[posicion].practice;
                objSt1.question = this.dataSource[posicion].statement1;
                objSt2.question = this.dataSource[posicion].statement2;
              }
              idiomasNuevaPreguntaEmpresaStatement1.push(objSt1);
              idiomasNuevaPreguntaEmpresaStatement2.push(objSt2);

            }
          });

          if (this.dataSource[posicion].objetoStatement1) {   //si ya existe el objeto del statement 1 en datasource
            let indiceStatement1= this.seccionesDemo[0].questions.findIndex(item => item.idUnique==this.dataSource[posicion].objetoStatement1.idUnique);
            let indiceIdioma=  this.seccionesDemo[0].questions[indiceStatement1].questionLanguage.findIndex(item=> item.lang==this.idiomaNative);

            this.seccionesDemo[0].questions[indiceStatement1].questionLanguage[indiceIdioma].practice4all=this.dataSource[posicion].practice;
            this.seccionesDemo[0].questions[indiceStatement1].questionLanguage[indiceIdioma].description4all=this.dataSource[posicion].description;
            this.seccionesDemo[0].questions[indiceStatement1].questionLanguage[indiceIdioma].question=this.dataSource[posicion].statement1;

            if (this.dataSource[posicion].objetoStatement2){  //si ya existe el objeto del statement 2 en datasource
              let indiceStatement2= this.seccionesDemo[0].questions.findIndex(item => item.idUnique==this.dataSource[posicion].objetoStatement2.idUnique);
              let indiceIdioma=  this.seccionesDemo[0].questions[indiceStatement2].questionLanguage.findIndex(item=> item.lang==this.idiomaNative);

              this.seccionesDemo[0].questions[indiceStatement2].questionLanguage[indiceIdioma].practice4all=this.dataSource[posicion].practice;
              // this.seccionesDemo[0].questions[indiceStatement2].questionLanguage[indiceIdioma].description4all=this.dataSource[posicion].description;
              this.seccionesDemo[0].questions[indiceStatement2].questionLanguage[indiceIdioma].question=this.dataSource[posicion].statement2;
            }
            else{   //si no existe lo crea y agrega
              let datosstatement2: any = {
                answerType: 5,
                answers: this.catalogoRespReactivos,
                color: 1,
                columns: this.jsonCuestionario.columns,
                delete: true,
                edit: true,
                idUnique: this.buscaUltimaIdUnique1000(),
                order: 1,
                preload: false,
                questionLanguage: idiomasNuevaPreguntaEmpresaStatement2,
                required: 1,
                typeAdd: 0, //enCM es ahora "typeAdd", 0 es pregunta en tempalte, 1 es pregunta de catalogo no en template y 2 es pregunta nueva no en template ni catalogo
                versionId: 1,
                vivo: 1,
                editarPregunta: false
              };

              this.dataSource[posicion].objetoStatement2=datosstatement2;
              this.seccionesDemo[0].questions.push(datosstatement2);

              // this.dataSource[posicion].objetoStatement1.answers.forEach(element => {
              //   element.logics.push({
              //     idUniqueQuestion: this.dataSource[posicion].objetoStatement1.idUnique,
              //     idUniqueQuestionDaughter: this.dataSource[posicion].objetoStatement2.idUnique,
              //   });
              // });

              //agrega la logics a la primera respuesta ("SI")
              this.dataSource[posicion].objetoStatement1.answers[0].logics.push({
                idUniqueQuestion: this.dataSource[posicion].objetoStatement1.idUnique,
                idUniqueQuestionDaughter: this.dataSource[posicion].objetoStatement2.idUnique,
              });
            }
          }
          else{   //si no existe el objeto del statement 1 en datasource lo crea y agrega
            console.log("entro el else");
            let datosstatement1: any = {
              answerType: 5,
              answers: objetoStatement1,
              color: 1,
              columns: this.jsonCuestionario.columns,
              delete: true,
              edit: true,
              idUnique: this.buscaUltimaIdUnique1000(),
              order: 1,
              preload: false,
              questionLanguage: idiomasNuevaPreguntaEmpresaStatement1,
              required: 1,
              typeAdd: 0, //enCM es ahora "typeAdd", 0 es pregunta en tempalte, 1 es pregunta de catalogo no en template y 2 es pregunta nueva no en template ni catalogo
              versionId: 1,
              vivo: 1,
              editarPregunta: false
            };
            this.dataSource[posicion].objetoStatement1=datosstatement1;
            this.seccionesDemo[0].questions.push(datosstatement1);
            console.log("datos nueva pregunta ya esta statement1 ",datosstatement1);

            //si el objeto del statement 1 no existe, por default el del statement 2 tampoco, entonces se crea y agrega
            let datosstatement2: any = {
              answerType: 5,
              answers: this.catalogoRespReactivos,
              color: 1,
              columns: this.jsonCuestionario.columns,
              delete: true,
              edit: true,
              idUnique: this.buscaUltimaIdUnique1000(),
              order: 1,
              preload: false,
              questionLanguage: idiomasNuevaPreguntaEmpresaStatement2,
              required: 1,
              typeAdd: 0, //enCM es ahora "typeAdd", 0 es pregunta en tempalte, 1 es pregunta de catalogo no en template y 2 es pregunta nueva no en template ni catalogo
              versionId: 1,
              vivo: 1,
              editarPregunta: false
            };

            this.dataSource[posicion].objetoStatement2=datosstatement2;
            this.seccionesDemo[0].questions.push(datosstatement2);

            //se crea el objeto al arreglo logics del statement 2, con el ID unique de la pregunta padre e hija
            this.dataSource[posicion].objetoStatement1.answers[0].logics.push({
              idUniqueQuestion: this.dataSource[posicion].objetoStatement1.idUnique,
              idUniqueQuestionDaughter: this.dataSource[posicion].objetoStatement2.idUnique,
            });


          }
          console.log("objetoStatement1",this.dataSource[posicion].objetoStatement1);
          console.log("objetoStatement2",this.dataSource[posicion].objetoStatement2);
          console.log("secciones demo perronas",this.seccionesDemo);
          this.actualizaCuestionario(tipo,accionText);
        }
        else console.log("es el mismo texto nomms :v");

      }
    }
  }

  actualizaCuestionario(tipo:number, accionText?:string){
    console.log('accionText',accionText);

    this.enviaSeccionesDemo();
    console.log("jsonCuestionario:",this.jsonCuestionario);
    console.log("seccionesDemo:",this.seccionesDemo);
    this.jsonCuestionario.accionText=accionText;
    this.jsonCuestionario.userAdministrator=this.nameUserAdmin;
    this.jsonCuestionario.section=6,
    this.jsonCuestionario.broker= parseInt(localStorage.getItem('instituto_id')),
    console.log("jsonCuestionarioActualizado:",this.jsonCuestionario);
    // this.guardandoTemplate.emit(true);
    this.preguntasService.setSeccionesCuestionario(this.productoCertificar.surveyProductId._id,this.jsonCuestionario).subscribe((respuesta:any) => {
      console.log("actualizaCuestionario:",respuesta);
      switch (tipo) {
        case 1:
          this.openSuccessSnackBar(this.translate.instant('CERTIFICAR.FORALL.MSJ_PRACTICEREGISTERED'),this.translate.instant('ALERTS.OK'));
        break;
        case 2:
          this.openSuccessSnackBar(this.translate.instant('CERTIFICAR.FORALL.MSJ_DESCRIPTIONREGISTERED'),this.translate.instant('ALERTS.OK'));
        break;
        case 3:
          this.openSuccessSnackBar('Se guardó la traducción correctamente',this.translate.instant('ALERTS.OK'));
        break;
      }
      this.surveyProductService.enviaDatosASurvProd({ actualizarProducto: true });
      Swal.close();
    });
  }

  modalGuardado(opcion:number){
    let mensaje: string;
    switch (opcion) {
      case 1:
        this.translate.get('CERTIFICAR.FORALL.CARGANDO_PRACTICA').subscribe((res: string) => { mensaje = res; });
      break;
      case 2:
        this.translate.get('CERTIFICAR.FORALL.CARGANDO_DESCRIPCION').subscribe((res: string) => { mensaje = res; });
      break;
    }
    Swal.fire({
      title: mensaje,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading()
      }
    });
  }

  openSuccessSnackBar(message: string, action: string) {
     this.snackBar.open(message, action, {
        duration: 5000,
        panelClass: ['background-success']
     });
  }

  getestatusform(){
    return this.formGroupForAll.status;
  }

  configuracionTemplate(modoAdmin: boolean){
    let totalPreguntas = 0;
    this.seccionesDemo.forEach(seccion => {
      totalPreguntas += seccion.questions.length;
    });
    const dialogRef = this.dialog.open(ModalComponent, {
      width: '50%',
      disableClose: true,
      data: {
        opcion: 'config',
        configTemplate: this.configTemplate,
        nombre: this.jsonCuestionario.name,
        secciones: this.seccionesDemo.length,
        preguntas: totalPreguntas,
        idiomas: this.idiomas,
        tipoSeccion: 6,
        modoAdmin
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log("RESULT CONFIG:",result);

      this.configTemplate = result;
      this.jsonCuestionario.editSections = result.secEditables;
      this.jsonCuestionario.addSections = result.nuevasSecciones;
      this.jsonCuestionario.deleteSections = result.secEliminables;
      this.jsonCuestionario.moveSections = result.secMovibles;
      this.jsonCuestionario.nameSections = result.secNombresObligatorios;

      this.seccionesDemo.forEach(seccion => {
        seccion.addCatQuestions = result.preguntasMC;
        seccion.addNewQuestions = result.nuevasPreguntas;
        seccion.deleteQuestions = result.eliminables;
        seccion.editQuestions = result.editables;
        seccion.moveQuestions = result.movibles;
        seccion.maxQuestions = result.limites.preguntasMaximas;
        seccion.enableAudio = result.audios;
        seccion.required4all = result.required4all;
        seccion.questions.forEach(practica => {
          practica.required = result.required4all == true ? 1 : 0;
        });
      });
      this.colocarPracticaForall();
      this.actualizaCuestionario(4);
    });
  }

  //// AUDIOS

  DEMO_convierteAudioBlob(base64:string){
    const b64toBlob = (b64Data, contentType='', sliceSize=512) => {
      const byteCharacters = atob(b64Data);
      const byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      const blob = new Blob(byteArrays, {type: contentType});
      return blob;
    }

    const contentType = 'audio/mpeg';
    const b64Data = base64;

    const blob = b64toBlob(b64Data, contentType);
    const blobUrl = URL.createObjectURL(blob);
    // this.blobAudio = this.sanitizer.bypassSecurityTrustResourceUrl(blobUrl);
    return blobUrl;
  }

  DEMO_buscaObjetoStatement(posicion:number, statement:number){
    let objetoStatement: any;
    if (this.dataSource[posicion].objetoStatement1) {   //si ya existe el objeto del statement 1 en datasource
      let nombreStatement: string;
      let refObjStt: any;
      // let datosPregunta: any
      switch (statement) {
        case 1: nombreStatement = 'objetoStatement1'; break;
        case 2: nombreStatement = 'objetoStatement2'; break;
      }
      refObjStt = this.seccionesDemo[0].questions.find(item => item.idUnique==this.dataSource[posicion][nombreStatement].idUnique);
      objetoStatement = refObjStt.questionLanguage.find(item=> item.lang==this.idiomaNative);
    }
    return objetoStatement;
  }

  DEMO_agregarAudioPregunta(posicion:number, statement:number, tipo:string){
    let datosPregunta = this.DEMO_buscaObjetoStatement(posicion, statement);
    const dialogRef = this.dialog.open(ModalComponent, {
      disableClose: true,
      width: '60%',
      data: {
        opcion: 'nuevoAudio',
        tipo,
        idiomas: this.idiomas,
        datosPregunta,
        practica4All: statement == 1 ? true : undefined
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result != undefined){
        if(result.base64 != undefined){
          datosPregunta.audio = true;
          datosPregunta.audioData = '';
          datosPregunta.audioUrl = ''
          setTimeout(() => {
            datosPregunta.audioData = result.base64;
            datosPregunta.audioUrl = result.url
            let accionText: string;
            switch (statement) {
              case 1: //practica
              accionText='savePracticaForall';
              break;
              case 2: //descripcion
              accionText='saveDescripForall';
              break;
            }
            this.actualizaCuestionario(statement,accionText);
          });
        }
      }
    });
  }

  DEMO_reproducirAudioPregunta(posicion:number, statement:number){
    const datosPregunta = this.DEMO_buscaObjetoStatement(posicion, statement);
    datosPregunta.audioUrl = this.DEMO_convierteAudioBlob(datosPregunta.audioData);
  }

  DEMO_borrarAudioPregunta(posicion:number, statement:number){
    let datosPregunta = this.DEMO_buscaObjetoStatement(posicion, statement);
    Swal.fire({
      icon: 'question',
      title: this.translate.instant('CERTIFICARV3.MODAL_AUDIO.MODALES.BORRAR'),
      showCancelButton: true,
      reverseButtons: true,
      cancelButtonText: this.translate.instant('CERTIFICARV3.MODAL_AUDIO.BOTONES.CANCELAR'),
      confirmButtonText: this.translate.instant('CERTIFICARV3.MODAL_AUDIO.BOTONES.ACEPTAR'),
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
      if (result.value) {
        const codigo = Math.random().toString(36).substring(7);
        Swal.fire({
          title: this.translate.instant('CERTIFICARV3.MODAL_AUDIO.MODALES.CONFIRMAR_BORRAR') + '<font color="red">' + codigo + '</font>',
          icon: 'info',
          input:'text',
          showCancelButton: true,
          reverseButtons: true,
          cancelButtonText: this.translate.instant('CERTIFICARV3.MODAL_AUDIO.BOTONES.CANCELAR'),
          confirmButtonText: this.translate.instant('CERTIFICARV3.MODAL_AUDIO.BOTONES.ACEPTAR')
        }).then( (borrar) => {
          if (borrar.value == codigo) {
            datosPregunta.audio = false;
            datosPregunta.audioData = '';
            datosPregunta.audioUrl = '';
            this.openSuccessSnackBar(this.translate.instant('CERTIFICARV3.MODAL_AUDIO.MODALES.BORRADO_OK'), "OK");
          } else{
            if(!borrar.dismiss){
              Swal.fire({
                icon: 'error',
                title: this.translate.instant('CERTIFICARV3.MODAL_AUDIO.MODALES.CODIGO_MAL'),
                showConfirmButton: true,
                confirmButtonText: this.translate.instant('CERTIFICARV3.MODAL_AUDIO.ACEPTAR')
              })
            }
          }
        });
      }
    });
  }

}
